import React, { Component } from "react";
import "./CustomDuty.scss";
import Select from "react-select";

import moment from "moment";
import CommonService from "../../../services/common-service";
import InfoService from "../../../services/info-service";
import { BreadcrumbsItem } from "react-breadcrumbs-dynamic";
import QueryForm from "../../Shared/QueryForm/QueryForm";
import ModalPopup from "../../Shared/ModalPopup/ModalPopup";

class CustomDuty extends Component {
  constructor() {
    super();
    this.commonService = new CommonService();
    this.infoService = new InfoService();

    this.state = {
      showQueryForm: false,
      engineCapacity: "",
      years: [],
      year: "",
      type: "",
      shipYear: "",
      shipMonth: "",
      shipDay: "",
      excRate: 283.80,
      totalDuty: 0,
      car: "",
      errors: {
        engineCapacity: "",
        year: "",
        type: "",
        shipYear: "",
        shipMonth: "",
        shipDay: "",
        excRate: "",
        date: "",
      },
    };
  }

  engineCapacities = [
    { label: "660cc - 800cc", value: "660cc - 800cc" },
    { label: "801cc - 1000cc", value: "801cc - 1000cc" },
    { label: "1001cc - 1300cc (Normal)", value: "1001cc - 1300cc (Normal)" },
    { label: "1001cc - 1300cc (Hybrid)", value: "1001cc - 1300cc (Hybrid)" },
    { label: "1301cc - 1500cc (Normal)", value: "1301cc - 1500cc (Normal)" },
    { label: "1301cc - 1500cc (Hybrid)", value: "1301cc - 1500cc (Hybrid)" },
    { label: "1501cc - 1600cc (Normal)", value: "1501cc - 1600cc (Normal)" },
    { label: "1501cc - 1600cc (Hybrid)", value: "1501cc - 1600cc (Hybrid)" },
    { label: "1601cc - 1800cc (Normal)", value: "1601cc - 1800cc (Normal)" },
    { label: "1601cc - 1800cc (Hybrid)", value: "1601cc - 1800cc (Hybrid)" },
    { label: "More then 1800cc", value: "> 1800cc" },
  ];

  typeOptions = [
    { label: "Normal", value: "Normal" },
    { label: "Hybrid", value: "Hybrid" },
  ];

  componentDidMount() {
    this.getYears();
    this.getExchangeRate();
  }

  getExchangeRate = () => {
    this.infoService.getExchangeRate("USD", "PKR").then((res) => {
      const { data } = res;
      console.log(data.result, 'USD');
      if (data.result) {
        this.setState({
          excRate: data.result.toFixed(3),
        });
      }
    });
  };

  handleChange = (e, actionMeta) => {
    if (e.target) {
      const { value, name, type, checked } = e.target;
      this.checkFormErrors(name, value);
      if (e.target.type === "date") {
        const split = value.split("-");
        this.setState({
          shipYear: split[0],
          shipMonth: split[1],
          shipDay: split[2],
        });
      } else {
        this.setState({
          ...this.state,
          [name]: type === "checkbox" ? checked : value,
        });
      }
    } else if (actionMeta && actionMeta.name) {
      const value = e.value;
      const { name } = actionMeta;
      this.checkFormErrors(name, value);
      this.setState({
        ...this.state,
        [name]: value,
      });
    }
  };

  isValidForm = (formData, errors) => {
    // debugger
    for (let key in formData) {
      this.checkFormErrors(key, formData[key]);
    }
    return this.commonService.checkFormValidity(this.state.errors);
  };

  checkFormErrors = (name, value) => {
    // debugger
    let errors = this.state.errors;
    switch (name) {
      case "engineCapacity":
        errors.engineCapacity = value === "" ? "Engine Capacity is required!" : "";
        break;
      case "year":
        errors.year = value === "" ? "Year is required!" : "";
        break;
      // case "type":
      //   errors.type = value === "" ? "Type is required!" : "";
      //   break;
      // case "shipYear":
      //   errors.shipYear = value === "" ? "Shipping Year is required!" : "";
      //   break;
      // case "shipMonth":
      //   errors.shipMonth = value === "" ? "Shipping Month is required!" : "";
      //   break;
      // case "shipDay":
      //   errors.shipDay = value === "" ? "Shipping Day is required!" : "";
      //   break;
      case "excRate":
        errors.excRate = value === "" ? "Exchange Rate is required!" : "";
        break;
      case "date":
        errors.date = value === "" ? "Shipping Date is required!" : "";
        break;
      default:
        break;
    }
    this.setState({ errors });
  };

  getYears = () => {
    let years = [];
    const curYear = new Date().getFullYear();
    for (let i = curYear; i >= curYear - 5; i--) {
      years.push({
        label: i + (curYear - i > 3 ? " (Jeep / Hiace / Commercial)" : curYear - i < 1 ? " (No Rebate)" : ""),
        value: i,
      });
    }
    this.setState({
      years: years.reverse(),
    });
  };

  getShipingDate = (type) => {
    let data = [];
    if (type === "year") {
      const curYear = new Date().getFullYear();
      for (let i = curYear - 1; i <= curYear; i++) {
        data.push({
          label: i + (curYear - i === 1 ? " (for last year calculations only)" : ""),
          value: i,
        });
      }
    } else if (type === "day") {
      for (let i = 31; i >= 1; i--) {
        data.push({ label: i, value: i });
      }
    }
    return data.reverse();
  };

  toggleQueryForm = () => {
    this.setState({
      showQueryForm: !this.state.showQueryForm,
    });
  };

  getSelectLabel(list = [], value) {
    if (list && list.length) {
      let val = list.filter((x) => x.value === value)[0];
      if (val) {
        return val.label;
      }
    }
  }

  submit = () => {
    const { year, shipYear, shipMonth, shipDay, engineCapacity, excRate, errors } = this.state;
    const type = engineCapacity.substring(engineCapacity.indexOf("(") + 1, engineCapacity.lastIndexOf(")"));
    const formData = {
      year,
      shipYear,
      shipMonth,
      shipDay,
      type,
      engineCapacity,
      excRate,
    };
    if (this.isValidForm(formData, errors)) {
      if (engineCapacity === "> 1800cc") {
        this.setState({
          car: `${this.getSelectLabel(this.engineCapacities, engineCapacity)} ${year} ${type}`,
        });
        this.toggleQueryForm();
        this.commonService.showToast("Please fill this form to calculate duty for more than 1800cc.", "info");
        return;
      }
      this.infoService
        .calculateCustomDuty(formData)
        .then((res) => {
          const { data } = res;
          if (data && data.duty) {
            this.setState({
              totalDuty: data.duty,
            });
          } else if (data && data.message) {
            this.commonService.showToast(data.message, "");
          }
        })
        .catch((err) => {
          this.commonService.showToast("Something went wrong!", "error");
          this.infoService.handleError(err);
        });
    }
  };

  render() {
    const { engineCapacity, years, year, type, excRate, errors, totalDuty, shipYear, shipMonth, shipDay, showQueryForm, car } = this.state;
    const dateNow = new Date();
    return (
      <section className="duty my-5">
        <div className="container">
          <h2 className="text-left text-primary">Custom Duty Calculator</h2>
          <h6 className="text-capitalize text-left text-primary">Find duty of Japenese used and new cars</h6>
          <div className="row mt-md-2 mt-3">
            <div className="col-lg-8 col-md-6 mb-md-0 mb-4">
              <div className="my-lg-5 my-3">
                <p className="mb-0 text-muted">Car can be imported (2019 and above)</p>
                <p className="mb-0 text-muted">SUV and jeeps can be imported (2017 and above)</p>
              </div>
              <button className="adp-btn adp-btn-secondary" onClick={() => this.toggleQueryForm()}>
                Custom Clearence at Your Door Step
              </button>
              <div className="flex mt-4">
                <img loading="lazy" src={require("../../../assets/Images/Image_1@2x.png")} />
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="card">
                <h4 className="text-center mb-3" style={{ fontSize: "22px" }}>
                  Enter Your Car Details
                </h4>
                <form>
                  <div className="form-group">
                    <div className="post-catagories-1">
                      <Select
                        className="rounded-pill mb-md-2 mb-0"
                        name="engineCapacity"
                        options={this.engineCapacities}
                        placeholder="Engine Size"
                        value={
                          engineCapacity
                            ? {
                                label: this.getSelectLabel(this.engineCapacities, engineCapacity),
                                value: engineCapacity,
                              }
                            : ""
                        }
                        onChange={this.handleChange}
                      />
                      {errors.engineCapacity && <div className="invalid-feedback d-block">{errors.engineCapacity}</div>}
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="post-catagories">
                      <Select
                        className="rounded-pill mb-md-2 mb-0"
                        name="year"
                        options={years}
                        placeholder="Year of manufacture"
                        value={
                          year
                            ? {
                                label: this.getSelectLabel(years, year),
                                value: year,
                              }
                            : ""
                        }
                        onChange={this.handleChange}
                      />
                      {errors.year && <div className="invalid-feedback d-block">{errors.abRegDate}</div>}
                    </div>
                  </div>

                  <div className="form-group">
                    <div className="post-catagories">
                      <input onChange={this.handleChange} className="form-control date-input mb-0" type="date" />
                      {errors.date && <div className="invalid-feedback d-block">{errors.date}</div>}
                    </div>
                  </div>

                  <div className="calculate-btn d-flex justify-content-center">
                    <button type="button" className="adp-btn adp-btn-secondary w-100 mb-3" onClick={this.submit}>
                      Calculate
                    </button>
                  </div>
                  <div className="row">
                    <div className="col-md-12 text-center">
                      <h2>
                        <span className="total-duty">
                          {totalDuty ? (
                            <span className="mt-3">
                              {new Intl.NumberFormat("jp-JP", {
                                style: "currency",
                                currency: "PKR",
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 0,
                              }).format(totalDuty)}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      </h2>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <ModalPopup isOpen={showQueryForm} onModalClose={this.toggleQueryForm} className="query-form" backdrop={"static"}>
              {" "}
              <QueryForm modalClose={this.toggleQueryForm} carInfo={car} type="car-duty-calculator" />{" "}
            </ModalPopup>
          </div>
        </div>
      </section>
    );
  }
}
export default CustomDuty;
